import { defineComponent as _defineComponent } from 'vue'
import { REFERENCE_PERIOD_SELECT_OPTIONS } from '~/functions/referencePeriods'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferenceYears',
  props: {
  value: {
    type: Array as PropType<string[]>,
    required: true,
  },
  useIcon: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
},
  emits: ["input"],
  setup(__props) {

const allowedPeriodItems = REFERENCE_PERIOD_SELECT_OPTIONS.map((value) => ({
  text: value,
  value,
}))





return { __sfc: true,allowedPeriodItems }
}

})